import { envOrigin } from "./requireEnv";

export const API_ORIGIN = envOrigin("REACT_APP_API_URL");
export const FRONTEND_ORIGIN = envOrigin("REACT_APP_FRONTEND_URL");

export const BASE_URL = `${API_ORIGIN}/api/`;
export const IMAGE_URL = API_ORIGIN;

/** Absolute URL on the admin frontend, e.g. appUrl("/login") */
export const appUrl = (path = "/") => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${FRONTEND_ORIGIN}${normalized}`;
};
